import { render, staticRenderFns } from "./AcegatePromo.vue?vue&type=template&id=dce6c3a4&scoped=true&"
import script from "./AcegatePromo.vue?vue&type=script&lang=js&"
export * from "./AcegatePromo.vue?vue&type=script&lang=js&"
import style0 from "./AcegatePromo.vue?vue&type=style&index=0&id=dce6c3a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce6c3a4",
  null
  
)

export default component.exports